<template>
  <div class="v3-widget v3-panel" v-testid="testid">
    <div class="v3-panel-head">
      <h3 v-testid="testid + '-title'">{{ title }}</h3>
      <span v-if="ai.count.value" class="v3-count">{{ ai.count.value }}</span>
    </div>

    <V3Skeleton v-if="ai.isLoading.value && !ai.count.value" shape="list" :heading="false" />
    <div v-else-if="!ai.count.value" class="v3-task-empty" v-testid="testid + '-empty'">
      No anomalies or gaps detected across the levelling estate.
    </div>

    <div v-else class="v3-list">
      <div v-for="(r, i) in ai.rows.value" :key="'anom' + i" class="v3-row v3-row--2" v-testid="testid + '-row-' + r.title">
        <span class="v3-anom">
          <span class="v3-anom-ic" :class="ai.sevClass(r)"><span class="ms">{{ r.icon || 'flag' }}</span></span>
          <span class="v3-anom-main">
            <span class="v3-row-title">{{ r.title }}</span>
            <span class="v3-row-sub">{{ r.detail }}</span>
          </span>
        </span>
        <span class="v3-audit-n">{{ r.count }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { anomalies } from "@rm-ui/homepage/anomalies";
import V3Skeleton from "./cLandingV3Skeleton";

// New-portal (v3) Anomalies & insights — the prototype's governance panel
// (V3Insights): severity-toned rows for function-level grade skew, the
// org-wide anomaly rollup, and rationale/scoring gaps. Live from
// `POST Report/anomalies`; informational (the actionable per-role lists live
// in AdminPriority/AttentionQueue/Calibration).
// Sibling: rm-portal-beta AnomalyInsightsWidget.vue.
export default {
  name: "cLandingV3Insights",
  components: { V3Skeleton },
  props: {
    definition: { type: Object, default: () => ({}) },
    editMode: { type: Boolean, default: false },
    qaActions: { type: Array, default: () => [] },
  },
  setup(props) {
    const ai = anomalies({
      http: axios,
      getLimit: () => props.definition.limit || 6,
    });
    return { ai };
  },
  computed: {
    testid() {
      return this.definition.controlType || "v3Insights";
    },
    title() {
      return this.definition.title || "Anomalies & insights";
    },
  },
};
</script>

<style lang="scss" src="./v3Widgets.scss"></style>
